module.exports = __webpack_public_path__ + "static/pattern-widget-highlight-ce8f38fc431bef8817228d5a0ef4790a.png";